import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import moment from 'moment';

const FbStaticText= () => {
  const [timelineData] = useState([
    {
      date: '2025-10-01',
      actions: [
        {
          action: 'Input Added',
          performer: { name: 'User 1' },
          subtitle: 'Lorem Ipsum',
          description: 'Lorem ipsum dolor sit amet consectetur. Quisque nisl consequat amet volutpat sit tempor iaculis nisl. Pellentesque vestibulum non morbi vulputate. In ipsum blandit felis dictum purus neque faucibus tincidunt consectetur. Condimentum habitant morbi turpis at. Varius elit felis amet elit.',
        },
      ],
    },
    {
      date: '2025-10-05',
      actions: [
        {
          action: 'Input Added',
          performer: { name: 'User 1' },
          subtitle: 'Lorem Ipsum',
          description: 'Lorem ipsum dolor sit amet consectetur. Quisque nisl consequat amet volutpat sit tempor iaculis nisl. Pellentesque vestibulum non morbi vulputate. In ipsum blandit felis dictum purus neque faucibus tincidunt consectetur. Condimentum habitant morbi turpis at. Varius elit felis amet elit.',
        },
        {
          action: 'Input Property Updated',
          performer: { name: 'Admin' },
          subtitle: 'Lorem Ipsum',
          description: 'Lorem ipsum dolor sit amet consectetur. Quisque nisl consequat amet volutpat sit tempor iaculis nisl. Pellentesque vestibulum non morbi vulputate. In ipsum blandit felis dictum purus neque faucibus tincidunt consectetur. Condimentum habitant morbi turpis at. Varius elit felis amet elit.',
        },
      ],
    },
     {
      date: '2025-10-10',
      actions: [
        {
          action: 'Input Added',
          performer: { name:  'Admin'},
          subtitle: 'Lorem Ipsum',
          description: 'Lorem ipsum dolor sit amet consectetur. Quisque nisl consequat amet volutpat sit tempor iaculis nisl. Pellentesque vestibulum non morbi vulputate. In ipsum blandit felis dictum purus neque faucibus tincidunt consectetur. Condimentum habitant morbi turpis at. Varius elit felis amet elit.',
        },
             ],
    },
      
  ]);

  const formatTextLabel = (text = "") => text.replace(/_/g, " ");

  return (
    <Box className="bg-white rounded-2xl p-3">
      <Typography variant="subtitle1" fontWeight="bold">
        Template Timeline
      </Typography>

      <Box>
        <Timeline
          position="right"
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
          }}
        >
          {timelineData.map(({ date, actions }, index) => (
            <TimelineItem key={date}>
              <TimelineSeparator>
                <TimelineDot color="success" />
                {index !== timelineData.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent>
                <Chip
                  size="small"
                  color="success"
                  label={moment(date).format('DD/MM/YYYY')}
                  className="mb-[0.625rem]"
                />

                               {Array.isArray(actions) ? (
  actions.map((item, i) => (
    <Box
      key={i}
      className="w-full bg-gray-100 p-3 rounded-md mb-2"
    >
      <Typography variant="body1" className="text-gray-800 font-semibold">
        {formatTextLabel(item?.action)}
      </Typography>

      <Box className="flex flex-wrap items-end justify-between mb-1">
        <Box className="flex-1 min-w-0">
          {item.subtitle && (
            <Typography variant="body2" className="text-[#828282] mr-2">
              {item.subtitle}
            </Typography>
          )}
          {item.description && (
            <Typography variant="body2" className="text-[#000000] pt-2">
              {item.description}
            </Typography>
          )}
        </Box>

        <Box className="text-right ml-2 shrink-0">
          <Typography variant="body2" className="text-[#828282] font-normal mr-1">
            Action By
          </Typography>
          <Typography variant="body2" className="text-[#000000] font-semibold mr-1 pr-3">
            {item?.performer?.name}
          </Typography>
        </Box>
      </Box>
    </Box>
  ))
) : (
  <Typography variant="body2" color="text.secondary">
    No actions available
  </Typography>
)}

              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Box>
    </Box>
  );
};

export default FbStaticText;
